import { render, staticRenderFns } from "./notes_list.vue?vue&type=template&id=18065b55&"
import script from "./notes_list.vue?vue&type=script&lang=js&"
export * from "./notes_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports